/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import { RigidBody } from '@react-three/rapier'
export function Island(props) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF("/models/pirate_island.glb");
  const { actions } = useAnimations(animations, group);
  return <>
    {/* <RigidBody
        colliders="hull"
        type="fixed"
    > */}
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group
          name="Sketchfab_model"
          position={[-1.342, 0, 0.216]}
          rotation={[-Math.PI / 2, 0, 0]}
        >
          <group name="root">
            <group name="GLTF_SceneRootNode" rotation={[Math.PI / 2, 0, 0]}>
              <group
                name="Algae005_122"
                position={[20.773, -0.223, -16.364]}
                rotation={[0.025, -1.164, -3.119]}
                scale={0.615}
              >
                <mesh
                  name="Object_280"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_280.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae006_123"
                position={[21.46, -0.364, -17.635]}
                rotation={[0.147, -1.503, -2.995]}
                scale={0.069}
              >
                <mesh
                  name="Object_282"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_282.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae007_124"
                position={[22.288, -0.237, -14.441]}
                rotation={[3.099, -1.337, -0.041]}
                scale={0.818}
              >
                <mesh
                  name="Object_284"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_284.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae008_125"
                position={[18.613, -0.223, -16.364]}
                rotation={[0.025, -1.17, -3.118]}
                scale={0.251}
              >
                <mesh
                  name="Object_286"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_286.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae009_126"
                position={[19.3, -0.364, -17.635]}
                rotation={[3.131, -0.344, -0.004]}
                scale={0.744}
              >
                <mesh
                  name="Object_288"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_288.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae010_127"
                position={[20.129, -0.4, -14.441]}
                rotation={[0.019, -1.015, -3.126]}
                scale={0.859}
              >
                <mesh
                  name="Object_290"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_290.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae011_128"
                position={[18.613, -0.403, 13.874]}
                rotation={[0.014, -0.801, -3.131]}
                scale={0.303}
              >
                <mesh
                  name="Object_292"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_292.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae012_129"
                position={[19.3, -0.34, 14.763]}
                rotation={[0.019, -1.024, -3.125]}
                scale={0.322}
              >
                <mesh
                  name="Object_294"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_294.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae013_130"
                position={[20.129, -0.248, 15.798]}
                rotation={[0.01, -0.112, -3.14]}
                scale={0.346}
              >
                <mesh
                  name="Object_296"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_296.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae014_131"
                position={[18.613, -0.44, 18.194]}
                rotation={[0.011, -0.483, -3.136]}
                scale={0.685}
              >
                <mesh
                  name="Object_298"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_298.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae015_132"
                position={[19.3, -0.376, 16.923]}
                rotation={[2.995, -1.503, -0.147]}
                scale={0.859}
              >
                <mesh
                  name="Object_300"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_300.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae016_133"
                position={[20.129, -0.445, 20.117]}
                rotation={[0.084, -1.453, -3.058]}
                scale={0.097}
              >
                <mesh
                  name="Object_302"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_302.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae017_134"
                position={[16.454, -0.228, 13.874]}
                rotation={[3.131, -0.463, -0.005]}
                scale={0.522}
              >
                <mesh
                  name="Object_304"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_304.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae018_135"
                position={[17.14, -0.24, 12.603]}
                rotation={[0.01, -0.32, -3.138]}
                scale={0.62}
              >
                <mesh
                  name="Object_306"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_306.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae019_136"
                position={[17.969, -0.368, 13.638]}
                rotation={[0.015, -0.852, -3.13]}
                scale={0.652}
              >
                <mesh
                  name="Object_308"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_308.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae020_137"
                position={[16.454, -0.228, 13.874]}
                rotation={[0.016, -0.907, -3.129]}
                scale={0.005}
              >
                <mesh
                  name="Object_310"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_310.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae021_138"
                position={[17.14, -0.354, 14.763]}
                rotation={[3.125, -0.939, -0.013]}
                scale={0.595}
              >
                <mesh
                  name="Object_312"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_312.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae022_139"
                position={[17.969, -0.434, 15.798]}
                rotation={[0.03, -1.241, -3.113]}
                scale={0.768}
              >
                <mesh
                  name="Object_314"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_314.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae023_140"
                position={[16.454, -0.431, 16.034]}
                rotation={[0.016, -0.889, -3.129]}
                scale={0.192}
              >
                <mesh
                  name="Object_316"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_316.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae024_141"
                position={[17.14, -0.354, 14.763]}
                rotation={[0.023, -1.124, -3.121]}
                scale={0.375}
              >
                <mesh
                  name="Object_318"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_318.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae025_142"
                position={[17.969, -0.434, 15.798]}
                rotation={[0.031, -1.249, -3.112]}
                scale={0.487}
              >
                <mesh
                  name="Object_320"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_320.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae026_143"
                position={[16.454, -0.233, 20.354]}
                rotation={[3.121, -1.071, -0.018]}
                scale={0.585}
              >
                <mesh
                  name="Object_322"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_322.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae027_144"
                position={[14.98, -0.205, -17.635]}
                rotation={[3.064, -1.443, -0.077]}
                scale={0.377}
              >
                <mesh
                  name="Object_324"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_324.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae028_145"
                position={[15.809, -0.205, -16.601]}
                rotation={[0.013, -0.675, -3.134]}
                scale={0.91}
              >
                <mesh
                  name="Object_326"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_326.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae029_146"
                position={[14.294, -0.205, -16.364]}
                rotation={[3.125, -0.912, -0.013]}
                scale={0.326}
              >
                <mesh
                  name="Object_328"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_328.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae030_147"
                position={[14.98, -0.205, -17.635]}
                rotation={[3.131, -0.239, -0.002]}
                scale={0.256}
              >
                <mesh
                  name="Object_330"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_330.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae031_148"
                position={[15.809, -0.205, -16.601]}
                rotation={[0.02, -1.053, -3.124]}
                scale={0.329}
              >
                <mesh
                  name="Object_332"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_332.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae032_149"
                position={[14.294, -0.228, -14.204]}
                rotation={[3.13, -0.546, -0.006]}
                scale={0.03}
              >
                <mesh
                  name="Object_334"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_334.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae033_150"
                position={[14.98, -0.24, -15.476]}
                rotation={[0.01, -0.23, -3.139]}
                scale={0.152}
              >
                <mesh
                  name="Object_336"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_336.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae034_151"
                position={[15.809, -0.368, -14.441]}
                rotation={[0.011, -0.352, -3.138]}
                scale={0.53}
              >
                <mesh
                  name="Object_338"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_338.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae035_152"
                position={[14.294, -0.228, -14.204]}
                rotation={[0.045, -1.35, -3.098]}
                scale={0.47}
              >
                <mesh
                  name="Object_340"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_340.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae036_153"
                position={[14.98, -0.24, -15.476]}
                rotation={[3.079, -1.413, -0.062]}
                scale={0.871}
              >
                <mesh
                  name="Object_342"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_342.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae037_154"
                position={[15.809, -0.368, -14.441]}
                rotation={[0.011, -0.416, -3.137]}
                scale={0.099}
              >
                <mesh
                  name="Object_344"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_344.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae038_155"
                position={[14.294, -0.228, -14.204]}
                rotation={[3.126, -0.89, -0.012]}
                scale={0.273}
              >
                <mesh
                  name="Object_346"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_346.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae039_156"
                position={[14.98, -0.319, -13.316]}
                rotation={[0.011, -0.411, -3.137]}
                scale={0.291}
              >
                <mesh
                  name="Object_348"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_348.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae040_157"
                position={[15.809, -0.271, -12.281]}
                rotation={[3.124, -0.958, -0.014]}
                scale={0.715}
              >
                <mesh
                  name="Object_350"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_350.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae041_158"
                position={[14.294, -0.407, -12.044]}
                rotation={[3.132, -0.205, -0.002]}
                scale={0.4}
              >
                <mesh
                  name="Object_352"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_352.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae042_159"
                position={[14.98, -0.319, -13.316]}
                rotation={[3.129, -0.621, -0.007]}
                scale={0.285}
              >
                <mesh
                  name="Object_354"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_354.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae043_160"
                position={[15.809, -0.271, -12.281]}
                rotation={[3.126, -0.868, -0.012]}
                scale={0.362}
              >
                <mesh
                  name="Object_356"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_356.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae044_161"
                position={[14.294, -0.205, 13.874]}
                rotation={[3.131, -0.384, -0.004]}
                scale={0.403}
              >
                <mesh
                  name="Object_358"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_358.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae045_162"
                position={[14.98, -0.205, 12.603]}
                rotation={[0.01, -0.051, -3.141]}
                scale={0.672}
              >
                <mesh
                  name="Object_360"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_360.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae046_163"
                position={[15.809, -0.368, 15.798]}
                rotation={[3.086, -1.392, -0.055]}
                scale={0.55}
              >
                <mesh
                  name="Object_362"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_362.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae047_164"
                position={[14.294, -0.228, 16.034]}
                rotation={[3.059, -1.45, -0.082]}
                scale={0.215}
              >
                <mesh
                  name="Object_364"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_364.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae048_165"
                position={[14.98, -0.24, 14.763]}
                rotation={[0.025, -1.168, -3.118]}
                scale={0.724}
              >
                <mesh
                  name="Object_366"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_366.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae049_166"
                position={[15.809, -0.238, 17.957]}
                rotation={[3.102, -1.317, -0.038]}
                scale={0.945}
              >
                <mesh
                  name="Object_368"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_368.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae050_167"
                position={[14.294, -0.205, 20.354]}
                rotation={[3.131, -0.396, -0.004]}
                scale={0.339}
              >
                <mesh
                  name="Object_370"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_370.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae051_168"
                position={[12.82, -0.205, -17.635]}
                rotation={[3.127, -0.855, -0.011]}
                scale={0.844}
              >
                <mesh
                  name="Object_372"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_372.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae052_169"
                position={[13.649, -0.205, -16.601]}
                rotation={[0.022, -1.096, -3.122]}
                scale={0.069}
              >
                <mesh
                  name="Object_374"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_374.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae053_170"
                position={[12.134, -0.205, -16.364]}
                rotation={[3.13, -0.514, -0.006]}
                scale={0.109}
              >
                <mesh
                  name="Object_376"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_376.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae054_171"
                position={[12.82, -0.205, -17.635]}
                rotation={[3.131, -0.438, -0.005]}
                scale={0.436}
              >
                <mesh
                  name="Object_378"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_378.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae055_172"
                position={[13.649, -0.237, -14.441]}
                rotation={[0.01, -0.054, -3.141]}
                scale={0.56}
              >
                <mesh
                  name="Object_380"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_380.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae056_173"
                position={[12.134, -0.403, -14.204]}
                rotation={[3.13, -0.517, -0.006]}
                scale={0.13}
              >
                <mesh
                  name="Object_382"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_382.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae057_174"
                position={[12.82, -0.25, -15.476]}
                rotation={[3.13, -0.585, -0.007]}
                scale={0.731}
              >
                <mesh
                  name="Object_384"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_384.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae058_175"
                position={[13.649, -0.237, -14.441]}
                rotation={[3.113, -1.215, -0.027]}
                scale={0.128}
              >
                <mesh
                  name="Object_386"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_386.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae059_176"
                position={[12.134, -0.403, -14.204]}
                rotation={[3.091, -1.374, -0.049]}
                scale={0.709}
              >
                <mesh
                  name="Object_388"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_388.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae060_177"
                position={[12.82, -0.25, -15.476]}
                rotation={[3.131, -0.367, -0.004]}
                scale={0.956}
              >
                <mesh
                  name="Object_390"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_390.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae061_178"
                position={[13.649, -0.237, -14.441]}
                rotation={[3.124, -0.968, -0.014]}
                scale={0.82}
              >
                <mesh
                  name="Object_392"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_392.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae062_179"
                position={[12.134, -0.403, -14.204]}
                rotation={[0.024, -1.156, -3.119]}
                scale={0.739}
              >
                <mesh
                  name="Object_394"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_394.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae063_180"
                position={[12.82, -0.25, -15.476]}
                rotation={[1.148, -1.56, -1.993]}
                scale={0.897}
              >
                <mesh
                  name="Object_396"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_396.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae064_181"
                position={[13.649, -0.237, -14.441]}
                rotation={[0.011, -0.472, -3.137]}
                scale={0.01}
              >
                <mesh
                  name="Object_398"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_398.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae065_182"
                position={[12.134, -0.44, -12.044]}
                rotation={[0.011, -0.497, -3.136]}
                scale={0.567}
              >
                <mesh
                  name="Object_400"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_400.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae066_183"
                position={[12.82, -0.376, -13.316]}
                rotation={[3.101, -1.323, -0.039]}
                scale={0.548}
              >
                <mesh
                  name="Object_402"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_402.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae067_184"
                position={[13.649, -0.411, -12.281]}
                rotation={[0.012, -0.578, -3.135]}
                scale={0.376}
              >
                <mesh
                  name="Object_404"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_404.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae068_185"
                position={[12.134, -0.44, -12.044]}
                rotation={[3.129, -0.676, -0.008]}
                scale={0.592}
              >
                <mesh
                  name="Object_406"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_406.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae069_186"
                position={[12.82, -0.376, -13.316]}
                rotation={[3.125, -0.95, -0.014]}
                scale={0.893}
              >
                <mesh
                  name="Object_408"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_408.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae070_187"
                position={[13.649, -0.411, -12.281]}
                rotation={[0.045, -1.349, -3.098]}
                scale={0.743}
              >
                <mesh
                  name="Object_410"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_410.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae071_188"
                position={[12.134, -0.218, 18.194]}
                rotation={[3.131, -0.373, -0.004]}
                scale={0.353}
              >
                <mesh
                  name="Object_412"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_412.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae072_189"
                position={[12.82, -0.295, 16.923]}
                rotation={[0.01, -0.088, -3.141]}
                scale={0.855}
              >
                <mesh
                  name="Object_414"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_414.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae073_190"
                position={[13.649, -0.205, 20.117]}
                rotation={[3.13, -0.495, -0.005]}
                scale={0.88}
              >
                <mesh
                  name="Object_416"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_416.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae074_191"
                position={[9.974, -0.403, -16.364]}
                rotation={[0.012, -0.618, -3.135]}
                scale={0.011}
              >
                <mesh
                  name="Object_418"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_418.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae075_192"
                position={[10.661, -0.25, -17.635]}
                rotation={[0.01, -0.2, -3.14]}
                scale={0.854}
              >
                <mesh
                  name="Object_420"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_420.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae076_193"
                position={[11.489, -0.379, -14.441]}
                rotation={[3.13, -0.528, -0.006]}
                scale={0.831}
              >
                <mesh
                  name="Object_422"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_422.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae077_194"
                position={[9.974, -0.242, -14.204]}
                rotation={[0.045, -1.35, -3.098]}
                scale={0.625}
              >
                <mesh
                  name="Object_424"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_424.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae078_195"
                position={[10.661, -0.331, -15.476]}
                rotation={[3.129, -0.651, -0.008]}
                scale={0.573}
              >
                <mesh
                  name="Object_426"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_426.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae079_196"
                position={[11.489, -0.379, -14.441]}
                rotation={[0.011, -0.365, -3.138]}
                scale={0.903}
              >
                <mesh
                  name="Object_428"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_428.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae080_197"
                position={[9.974, -0.233, -12.044]}
                rotation={[0.01, -0.121, -3.14]}
                scale={0.706}
              >
                <mesh
                  name="Object_430"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_430.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae081_198"
                position={[4.181, -0.274, -21.955]}
                rotation={[3.109, -1.261, -0.031]}
                scale={0.372}
              >
                <mesh
                  name="Object_432"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_432.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae082_199"
                position={[5.009, -0.205, -18.761]}
                rotation={[3.073, -1.425, -0.067]}
                scale={0.507}
              >
                <mesh
                  name="Object_434"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_434.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae083_200"
                position={[-0.826, -0.403, -20.684]}
                rotation={[3.129, -0.67, -0.008]}
                scale={0.148}
              >
                <mesh
                  name="Object_436"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_436.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae084_201"
                position={[-0.139, -0.331, -19.795]}
                rotation={[0.011, -0.475, -3.137]}
                scale={0.156}
              >
                <mesh
                  name="Object_438"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_438.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae085_202"
                position={[-14.43, -0.379, -14.441]}
                rotation={[3.131, -0.305, -0.003]}
                scale={0.59}
              >
                <mesh
                  name="Object_440"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_440.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae086_203"
                position={[-15.665, 0.824, 17.937]}
                rotation={[2.822, -1.539, -0.319]}
                scale={0.183}
              >
                <mesh
                  name="Object_442"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_442.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae087_204"
                position={[-17.252, 0.197, 16.753]}
                rotation={[0.03, -1.236, -3.113]}
                scale={0.802}
              >
                <mesh
                  name="Object_444"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_444.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae088_205"
                position={[-16.31, 0.753, 17.692]}
                rotation={[0.011, -0.357, -3.138]}
                scale={0.712}
              >
                <mesh
                  name="Object_446"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_446.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae089_206"
                position={[-18.004, -0.054, 20.242]}
                rotation={[3.064, -1.442, -0.077]}
                scale={0.436}
              >
                <mesh
                  name="Object_448"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_448.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae090_207"
                position={[-17.175, 0.548, 18.834]}
                rotation={[0.131, -1.495, -3.011]}
                scale={0.901}
              >
                <mesh
                  name="Object_450"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_450.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae091_208"
                position={[-18.749, -0.401, 2.838]}
                rotation={[3.129, -0.675, -0.008]}
                scale={0.022}
              >
                <mesh
                  name="Object_452"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_452.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae092_209"
                position={[-20.25, -0.189, 16.017]}
                rotation={[0.024, -1.139, -3.12]}
                scale={0.861}
              >
                <mesh
                  name="Object_454"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_454.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae093_210"
                position={[-19.564, -0.282, 14.747]}
                rotation={[0.012, -0.625, -3.134]}
                scale={0.196}
              >
                <mesh
                  name="Object_456"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_456.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae094_211"
                position={[-18.506, 0.443, 17.688]}
                rotation={[3.13, -0.491, -0.005]}
                scale={0.059}
              >
                <mesh
                  name="Object_458"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_458.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Algae095_212"
                position={[-20.239, -0.353, 20.324]}
                rotation={[3.126, -0.881, -0.012]}
                scale={0.85}
              >
                <mesh
                  name="Object_460"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_460.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Anchor_9"
                position={[18.858, 0.108, -10.799]}
                rotation={[1.269, 0, 0]}
                scale={[1.316, 1.316, 0.79]}
              />
              <group
                name="Barrel001_435"
                position={[0.224, -10.701, 2.845]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              >
                <mesh
                  name="Object_914"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_914.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_915"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_915.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="Barrel002_436"
                position={[-6.573, 4.512, 7.41]}
                rotation={[Math.PI / 2, 1.312, 0]}
                scale={0.92}
              >
                <mesh
                  name="Object_917"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_917.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_918"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_918.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="Barrel003_437"
                position={[-7.267, 4.512, 7.41]}
                rotation={[Math.PI / 2, 1.312, 0]}
                scale={0.92}
              >
                <mesh
                  name="Object_920"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_920.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_921"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_921.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="Barrel004_438"
                position={[-6.949, 4.982, 7.434]}
                rotation={[Math.PI / 2, 1.312, 0]}
                scale={0.92}
              >
                <mesh
                  name="Object_923"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_923.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_924"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_924.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="Barrel005_439"
                position={[5.591, 4.103, 0.945]}
                rotation={[1.038, 1.2, -0.987]}
                scale={0.92}
              >
                <mesh
                  name="Object_926"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_926.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_927"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_927.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="Barrel006_440"
                position={[7.9, 4.618, 13.698]}
                scale={0.92}
              >
                <mesh
                  name="Object_929"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_929.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_930"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_930.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="Barrel_422"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="BezierCurve001_14"
                position={[5.457, 15.853, 5.791]}
                rotation={[0, -0.087, -Math.PI / 2]}
                scale={0.137}
              />
              <group
                name="BezierCurve002_16"
                position={[5.457, 15.853, 5.791]}
                rotation={[0, -0.087, 0]}
                scale={0.372}
              />
              <group
                name="BezierCurve003_19"
                position={[5.457, 15.853, 5.791]}
                rotation={[0, -1.551, 0]}
                scale={0.372}
              />
              <group
                name="BezierCurve004_430"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="BezierCurve005_429"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="BezierCurve006_36"
                position={[13.712, 2.976, 12.667]}
              >
                <mesh
                  name="Object_89"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_89.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="BezierCurve_66"
                position={[5.182, 8.612, 7.609]}
                rotation={[0, -0.863, -Math.PI / 2]}
                scale={0.08}
              >
                <mesh
                  name="Object_166"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_166.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="BoatMain_6"
                position={[16.121, 2.099, -5.805]}
                rotation={[-0.009, 0.226, 0.005]}
                scale={3.735}
              />
              <group
                name="Canon_28"
                position={[-12.196, 3.474, 9.197]}
                rotation={[0, -0.456, 0.143]}
              >
                <mesh
                  name="Object_71"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_71.geometry}
                  material={materials.MetallicPalette}
                />
                <mesh
                  name="Object_72"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_72.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="CanonBallSingle001_31"
                position={[-11.276, 3.634, 8.81]}
              >
                <mesh
                  name="Object_79"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_79.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="CanonBallSingle_29"
                position={[-11.295, 3.59, 8.437]}
              >
                <mesh
                  name="Object_74"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_74.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="CanonBallsPile_30"
                position={[-10.52, 3.663, 9.265]}
                rotation={[-0.282, 0.304, -0.043]}
              >
                <mesh
                  name="Object_76"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_76.geometry}
                  material={materials.MetallicPalette}
                />
                <mesh
                  name="Object_77"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_77.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group name="Chain_7" position={[17.804, 4.679, -11.194]} />
              <group
                name="Chest_3"
                position={[-10.774, -0.187, -13.178]}
                rotation={[-0.219, 0.185, 0]}
                scale={0.212}
              >
                <mesh
                  name="Object_11"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_11.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_12"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_12.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="Chimney_288"
                position={[-1.798, 12.12, 2.967]}
                rotation={[-Math.PI, 0.041, -Math.PI]}
                scale={2.663}
              >
                <mesh
                  name="Object_614"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_614.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="Crab001_33"
                position={[4.108, 3.17, 11.065]}
                rotation={[0.019, 0.458, 0.424]}
                scale={3.168}
              >
                <mesh
                  name="Object_83"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_83.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Crab002_34"
                position={[1.96, 2.335, 13.32]}
                rotation={[0.009, -0.9, -0.427]}
                scale={3.168}
              >
                <mesh
                  name="Object_85"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_85.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Crab003_37"
                position={[-13.762, -0.339, -13.727]}
                rotation={[3.086, -0.513, 3.131]}
                scale={3.168}
              >
                <mesh
                  name="Object_91"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_91.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Crab_32"
                position={[5.1, 3.532, 10.665]}
                rotation={[0.324, -0.265, 0.392]}
                scale={3.168}
              >
                <mesh
                  name="Object_81"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_81.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Crate_18"
                position={[5.457, 15.853, 5.791]}
                rotation={[0, -0.087, 0]}
                scale={0.372}
              />
              <group
                name="CrowsBeams_24"
                position={[0, 0.611, 0]}
                rotation={[0, 0, 0.05]}
              >
                <mesh
                  name="Object_62"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_62.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="CrowsFlag_25"
                position={[0, 0.611, 0]}
                rotation={[0, 0, 0.05]}
              >
                <mesh
                  name="Object_64"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_64.geometry}
                  material={materials.PirateFlag}
                />
              </group>
              <group
                name="CrowsMast_22"
                position={[0, 0.611, 0]}
                rotation={[0, 0, 0.05]}
              >
                <mesh
                  name="Object_57"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_57.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_58"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_58.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="CrowsNets_23"
                position={[0, 0.611, 0]}
                rotation={[0, 0, 0.05]}
              >
                <mesh
                  name="Object_60"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_60.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube008_97"
                position={[10.298, 4.184, 15.761]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_230"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_230.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube009_98"
                position={[9.898, 4.184, 15.462]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_232"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_232.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube010_99"
                position={[11.109, 4.182, 13.844]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_234"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_234.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube011_100"
                position={[9.53, 4.184, 15.186]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_236"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_236.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube012_101"
                position={[10.355, 4.184, 13.28]}
                rotation={[-3.141, 0.642, 3.141]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_238"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_238.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube013_102"
                position={[9.144, 4.182, 14.898]}
                rotation={[-3.141, 0.642, 3.141]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_240"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_240.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube014_103"
                position={[8.757, 4.183, 14.609]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_242"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_242.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube015_104"
                position={[9.968, 4.183, 12.99]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_244"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_244.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube016_89"
                position={[8.359, 4.183, 14.291]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_214"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_214.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube017_90"
                position={[7.959, 4.183, 13.992]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_216"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_216.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube018_91"
                position={[9.17, 4.183, 12.374]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_218"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_218.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube019_92"
                position={[7.591, 4.183, 13.717]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_220"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_220.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube020_93"
                position={[8.416, 4.183, 11.81]}
                rotation={[Math.PI, 0.642, 3.142]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_222"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_222.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube021_94"
                position={[7.205, 4.183, 13.428]}
                rotation={[Math.PI, 0.642, 3.142]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_224"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_224.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube022_95"
                position={[6.818, 4.183, 13.139]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_226"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_226.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube023_96"
                position={[8.029, 4.183, 11.521]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_228"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_228.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube026_105"
                position={[9.089, 3.872, 14.832]}
                rotation={[0, -0.631, 0]}
              >
                <mesh
                  name="Object_246"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_246.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube027_106"
                position={[10.26, 3.872, 13.23]}
                rotation={[0, -0.631, 0]}
              >
                <mesh
                  name="Object_248"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_248.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube028_107"
                position={[9.692, 3.872, 14.008]}
                rotation={[0, -0.631, 0]}
              >
                <mesh
                  name="Object_250"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_250.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube029_108"
                position={[10.221, 3.661, 16.121]}
                rotation={[-0.032, -0.01, -0.014]}
                scale={0.935}
              >
                <mesh
                  name="Object_252"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_252.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube030_109"
                position={[11.122, 2.572, 15.214]}
                rotation={[-0.067, 0, -0.048]}
                scale={0.935}
              >
                <mesh
                  name="Object_254"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_254.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube031_63"
                position={[5.182, 8.612, 7.609]}
                rotation={[0, -0.863, 0]}
                scale={0.08}
              >
                <mesh
                  name="Object_160"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_160.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube032_64"
                position={[5.182, 8.612, 7.609]}
                rotation={[0, -0.863, -Math.PI / 2]}
                scale={0.08}
              >
                <mesh
                  name="Object_162"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_162.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube033_65"
                position={[5.182, 8.612, 7.609]}
                rotation={[0, -0.863, -2.44]}
                scale={0.08}
              >
                <mesh
                  name="Object_164"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_164.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube034_11"
                position={[5.457, 15.853, 5.791]}
                rotation={[0, -0.087, 0]}
                scale={0.137}
              />
              <group
                name="Cube035_12"
                position={[5.457, 15.853, 5.791]}
                rotation={[0, -0.087, -Math.PI / 2]}
                scale={0.137}
              />
              <group
                name="Cube036_13"
                position={[5.457, 15.853, 5.791]}
                rotation={[0, -0.087, -2.44]}
                scale={0.137}
              />
              <group
                name="Cube037_15"
                position={[5.457, 15.853, 5.791]}
                rotation={[0, -0.087, 0]}
                scale={0.26}
              />
              <group
                name="Cube039_68"
                position={[5.048, 8.001, 5.181]}
                rotation={[0, 0.706, 0]}
                scale={0.053}
              >
                <mesh
                  name="Object_171"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_171.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube040_69"
                position={[4.271, 8.001, 4.271]}
                rotation={[0, 0.706, 0]}
                scale={0.053}
              >
                <mesh
                  name="Object_173"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_173.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube041_337"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube042_336"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube043_335"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube044_334"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube045_338"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube046_339"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube047_340"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube048_341"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube049_342"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube050_343"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube051_344"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube052_345"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube053_346"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube054_333"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube055_332"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube056_331"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube057_330"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube058_329"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube059_328"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube060_347"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube061_348"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube062_349"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube063_350"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube064_351"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube065_352"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube066_353"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube067_354"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube068_355"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube069_356"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube070_357"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube071_358"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube072_359"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube073_360"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube074_361"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube075_362"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube076_363"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube077_364"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube078_365"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube079_366"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube080_367"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube081_368"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube082_369"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube083_370"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube084_371"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube085_372"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube086_373"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube087_374"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube088_375"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube089_376"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube090_377"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube091_378"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube092_379"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube093_380"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube094_381"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube095_382"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube096_383"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube097_384"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube098_385"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube099_386"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube100_387"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube101_388"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube102_389"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube103_390"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube104_391"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube105_392"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube106_393"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube107_394"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube108_395"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube109_396"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube110_397"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube111_398"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube112_399"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube113_400"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube114_401"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube115_410"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube116_411"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube117_412"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube118_413"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube119_414"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube120_415"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube121_416"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube122_327"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube123_326"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube124_325"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube125_324"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube126_323"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube127_322"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube128_321"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube129_320"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube130_319"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube131_318"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube132_317"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube133_316"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube134_315"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube135_314"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube136_313"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube137_312"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube138_311"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube139_310"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube140_309"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube141_308"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube142_307"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube143_306"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube144_305"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube145_304"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube146_303"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube147_302"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube148_301"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube149_300"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube150_299"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cube151_110"
                position={[5.935, 3.656, 10.062]}
                rotation={[0, -0.642, 0]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_256"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_256.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube152_111"
                position={[5.287, 3.789, 9.514]}
                rotation={[0.084, -0.629, 0.057]}
                scale={[0.242, 0.242, 0.173]}
              >
                <mesh
                  name="Object_258"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_258.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube153_20"
                position={[-5.613, 4.527, 6.229]}
                rotation={[Math.PI, -1.426, Math.PI]}
                scale={0.372}
              >
                <mesh
                  name="Object_53"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_53.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cube154_21"
                position={[5.255, 4.318, 1.953]}
                rotation={[-2.961, -1.425, -2.738]}
                scale={0.372}
              >
                <mesh
                  name="Object_55"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_55.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cutlass_4"
                position={[-12.772, -0.365, -13.975]}
                rotation={[-0.907, 1.52, 0.866]}
              >
                <mesh
                  name="Object_14"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_14.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_15"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_15.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="Cylinder001_553"
                position={[5.693, 12.249, 4.887]}
                rotation={[1.761, 0.29, -2.164]}
                scale={[0.291, 0.577, 0.291]}
              >
                <mesh
                  name="Object_934"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_934.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cylinder002_554"
                position={[2.727, 12.249, 3.563]}
                rotation={[1.864, -0.185, 2.594]}
                scale={[0.291, 0.577, 0.291]}
              >
                <mesh
                  name="Object_936"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_936.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cylinder003_555"
                position={[1.302, 12.249, 6.084]}
                rotation={[1.439, -0.32, 1.173]}
                scale={[0.291, 0.577, 0.291]}
              >
                <mesh
                  name="Object_938"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_938.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cylinder004_556"
                position={[4.767, 9.174, 7.631]}
                rotation={[1.316, 0.236, -0.733]}
                scale={[0.291, 0.577, 0.291]}
              >
                <mesh
                  name="Object_940"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_940.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Cylinder005_425"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cylinder006_424"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cylinder007_426"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cylinder008_427"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cylinder009_428"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cylinder010_420"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cylinder011_418"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cylinder012_417"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Cylinder_552"
                position={[4.767, 12.249, 7.631]}
                rotation={[1.316, 0.236, -0.733]}
                scale={[0.291, 0.577, 0.291]}
              >
                <mesh
                  name="Object_932"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_932.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Fish001_272"
                position={[-18.725, 0.414, 4.467]}
                rotation={[0, 0.306, 0]}
                scale={[0.108, 0.194, 0.282]}
              >
                <mesh
                  name="Object_580"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_580.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Fish002_273"
                position={[-18.101, 0.954, 3.583]}
                rotation={[0, 0.306, 0]}
                scale={[0.119, 0.214, 0.312]}
              >
                <mesh
                  name="Object_582"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_582.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Fish003_274"
                position={[-6.145, 0.856, -15.896]}
                rotation={[0, -1.563, 0]}
                scale={[0.104, 0.188, 0.274]}
              >
                <mesh
                  name="Object_584"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_584.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Fish004_275"
                position={[-5.631, 0.452, -16.108]}
                rotation={[0, -1.563, 0]}
                scale={[0.168, 0.302, 0.44]}
              >
                <mesh
                  name="Object_586"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_586.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Fish005_276"
                position={[-5.046, 0.954, -16.837]}
                rotation={[0, -1.563, 0]}
                scale={[0.109, 0.196, 0.286]}
              >
                <mesh
                  name="Object_588"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_588.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Fish006_277"
                position={[16.811, 0.452, -15.25]}
                rotation={[-Math.PI, 0.124, -Math.PI]}
                scale={[0.168, 0.302, 0.44]}
              >
                <mesh
                  name="Object_590"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_590.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Fish007_278"
                position={[17.5, 0.936, -15.425]}
                rotation={[-Math.PI, 0.124, -Math.PI]}
                scale={[0.1, 0.181, 0.263]}
              >
                <mesh
                  name="Object_592"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_592.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Fish_121"
                position={[-19.2, 0.856, 4.523]}
                rotation={[0, 0.306, 0]}
                scale={[0.129, 0.232, 0.339]}
              >
                <mesh
                  name="Object_278"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_278.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="FlowerPot_431"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Grave1_38"
                position={[1.497, 4.117, -3.715]}
                rotation={[0.01, 0.111, 0.203]}
                scale={0.407}
              >
                <mesh
                  name="Object_93"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_93.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Grave2_39"
                position={[-0.627, 3.604, -4.879]}
                rotation={[3.126, -0.006, 2.986]}
                scale={0.407}
              >
                <mesh
                  name="Object_95"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_95.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="GraveDug_40"
                position={[-2.467, 3.973, -3.472]}
                rotation={[-0.167, 0.109, 0.1]}
                scale={0.407}
              >
                <mesh
                  name="Object_97"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_97.geometry}
                  material={materials.MetallicPalette}
                />
                <mesh
                  name="Object_98"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_98.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group name="GreenSmall001_84">
                <mesh
                  name="Object_204"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_204.geometry}
                  material={materials.Base_Island_Texture}
                />
              </group>
              <group name="GreenSmall_83">
                <mesh
                  name="Object_202"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_202.geometry}
                  material={materials.Base_Island_Texture}
                />
              </group>
              <group
                name="Hook_17"
                position={[5.457, 15.853, 5.791]}
                rotation={[Math.PI / 2, 0, 0.087]}
                scale={0.32}
              >
                <mesh
                  name="Object_47"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_47.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="House_286"
                position={[-1.417, 7.654, 1.213]}
                rotation={[-Math.PI, 0.041, -Math.PI]}
                scale={2.663}
              >
                <mesh
                  name="Object_609"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_609.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_610"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_610.geometry}
                  material={materials.EmissivePalette}
                />
              </group>
              <group
                name="HouseDoorPlatForm_296"
                position={[3.802, 7.631, 1.356]}
                rotation={[0, -0.715, 0]}
                scale={1.209}
              >
                <mesh
                  name="Object_630"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_630.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Ivy_287"
                position={[-6.463, 7.917, 4.019]}
                rotation={[0, -1.369, 0]}
                scale={2.663}
              >
                <mesh
                  name="Object_612"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_612.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="JellyFish001_5"
                position={[-3.594, 1.091, -18.718]}
                rotation={[-0.084, -0.087, 0.233]}
                scale={0.124}
              >
                <mesh
                  name="Object_17"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_17.geometry}
                  material={materials.Base_PaletteJellyFish}
                />
                <mesh
                  name="Object_18"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_18.geometry}
                  material={materials["Base_PaletteJellyFish.Emissive"]}
                />
              </group>
              <group
                name="JellyFish_1"
                position={[-3.97, 1.249, -18.815]}
                rotation={[-0.084, -0.087, 0.233]}
                scale={0.201}
              >
                <mesh
                  name="Object_6"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_6.geometry}
                  material={materials.Base_PaletteJellyFish}
                />
                <mesh
                  name="Object_7"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_7.geometry}
                  material={materials["Base_PaletteJellyFish.Emissive"]}
                />
              </group>
              <group
                name="LadderBeam1001_44"
                position={[11.909, 2.828, 14.105]}
                rotation={[-0.166, -0.608, -0.095]}
                scale={0.35}
              >
                <mesh
                  name="Object_109"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_109.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_110"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_110.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="LadderBeam1_41"
                position={[-1.552, 11.356, -0.886]}
                rotation={[-3.01, 0.26, 3.108]}
                scale={0.35}
              >
                <mesh
                  name="Object_101"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_101.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="LadderBeam2001_46"
                position={[11.951, 3.534, 14.075]}
                rotation={[0, -0.614, 0]}
                scale={0.35}
              >
                <mesh
                  name="Object_115"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_115.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_116"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_116.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="LadderBeam2_43"
                position={[-1.51, 12.197, -0.959]}
                rotation={[-3.055, 0.262, 3.119]}
                scale={0.35}
              >
                <mesh
                  name="Object_107"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_107.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="LaderBeam3001_45"
                position={[11.945, 3.171, 14.097]}
                rotation={[0.009, -0.614, 0.005]}
                scale={0.35}
              >
                <mesh
                  name="Object_112"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_112.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_113"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_113.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="LaderBeam3002_47"
                position={[-1.539, 12.689, -0.992]}
                rotation={[-Math.PI, 0.333, -Math.PI]}
                scale={0.296}
              >
                <mesh
                  name="Object_119"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_119.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="LaderBeam3_42"
                position={[-1.539, 11.795, -0.992]}
                rotation={[-0.004, -0.263, 3.141]}
                scale={0.35}
              />
              <group name="LandMass_81">
                <mesh
                  name="Object_198"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_198.geometry}
                  material={materials.Base_Island_Texture}
                />
              </group>
              <group
                name="LightHLens_75"
                position={[3.876, 15.204, 6.056]}
                rotation={[0, -0.874, 0]}
                scale={1.225}
              >
                <mesh
                  name="Object_186"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_186.geometry}
                  material={materials.Glass_Palette}
                />
              </group>
              <group
                name="LightHouseDoor001_77"
                position={[4.522, 8.59, 4.892]}
                rotation={[0, 1.461, 0]}
                scale={[0.869, 0.785, 1.163]}
              >
                <mesh
                  name="Object_190"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_190.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="LightHouseDoor_76"
                position={[4.325, 5.607, 6.62]}
                scale={[1, 0.921, 1]}
              >
                <mesh
                  name="Object_188"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_188.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="LightHouseF_70"
                position={[3.458, 3.993, 5.579]}
                rotation={[0, -0.874, 0]}
                scale={1.466}
              >
                <mesh
                  name="Object_175"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_175.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="LightHouseLightSupport_72"
                position={[3.553, 14.275, 5.69]}
                rotation={[0, -0.874, 0]}
                scale={1.466}
              >
                <mesh
                  name="Object_179"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_179.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="LightHousePlatform_78"
                position={[4.921, 8.169, 4.405]}
                rotation={[0, -0.845, 0]}
                scale={0.426}
              >
                <mesh
                  name="Object_192"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_192.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="LightHReflector_73"
                position={[3.456, 15.196, 5.575]}
                rotation={[0, 1.323, 0]}
                scale={0.847}
              >
                <mesh
                  name="Object_181"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_181.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group name="Main_Green_82" position={[-0.001, 0.049, 0]}>
                <mesh
                  name="Object_200"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_200.geometry}
                  material={materials.Base_Island_Texture}
                />
              </group>
              <group
                name="Outhouse_27"
                position={[-2.843, 3.596, -9.544]}
                rotation={[-0.132, -0.51, -0.058]}
                scale={1.329}
              >
                <mesh
                  name="Object_69"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_69.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="PalmTree001_87"
                position={[-0.172, 1.778, -7.662]}
                scale={0.465}
              >
                <mesh
                  name="Object_210"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_210.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="PalmTree002_88"
                position={[3.27, 1.783, -6.404]}
                scale={0.465}
              >
                <mesh
                  name="Object_212"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_212.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="PalmTree003_85"
                position={[-8.762, 3.51, 7.463]}
                rotation={[0.103, -0.032, -0.114]}
                scale={0.433}
              >
                <mesh
                  name="Object_206"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_206.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="PalmTree004_86"
                position={[7.541, 4.386, -19.32]}
                rotation={[-0.213, 0.05, -0.229]}
                scale={0.357}
              >
                <mesh
                  name="Object_208"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_208.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Plane001_402"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Plane002_403"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Plane003_404"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Plane004_405"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Plane005_406"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Plane006_407"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Plane007_408"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Plane008_409"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="Plane009_423"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="PlatformBeam1_112"
                position={[10.195, 2.691, 16.075]}
                rotation={[0, -0.706, 0]}
                scale={0.175}
              >
                <mesh
                  name="Object_260"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_260.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="PlatFormBeam2_113"
                position={[11.715, -0.371, 13.921]}
                rotation={[-Math.PI, 0.706, 0]}
                scale={0.175}
              >
                <mesh
                  name="Object_262"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_262.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Rock001_114"
                position={[9.326, -0.771, 15.666]}
                scale={2.117}
              >
                <mesh
                  name="Object_264"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_264.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Rock002_115"
                position={[15.956, -0.27, 15.783]}
                rotation={[Math.PI, -1.298, Math.PI]}
                scale={0.617}
              >
                <mesh
                  name="Object_266"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_266.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Rock003_116"
                position={[-11.079, -0.079, 20.85]}
                rotation={[-2.8, 1.28, -0.355]}
                scale={0.617}
              >
                <mesh
                  name="Object_268"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_268.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Rock004_117"
                position={[-20.164, 0.126, -5.507]}
                scale={1.392}
              >
                <mesh
                  name="Object_270"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_270.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Rock005_118"
                position={[-13.879, 0.249, -16.2]}
                rotation={[Math.PI / 2, 0, 0]}
                scale={0.579}
              >
                <mesh
                  name="Object_272"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_272.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Roof_285"
                position={[-1.417, 7.654, 1.213]}
                rotation={[-Math.PI, 0.041, -Math.PI]}
                scale={2.663}
              >
                <mesh
                  name="Object_606"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_606.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_607"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_607.geometry}
                  material={materials.EmissivePalette}
                />
              </group>
              <group
                name="Sand_119"
                position={[0, -0.445, 0]}
                rotation={[-Math.PI, 0, -Math.PI]}
                scale={[10.679, 17.786, 10.679]}
              >
                <mesh
                  name="Object_274"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_274.geometry}
                  material={materials.Base_Palette}
                  position={[0, 0.01, 0]}
                  scale={2.397}
                />
              </group>
              <group
                name="Shark_0"
                position={[-13.309, 1.989, 17.944]}
                rotation={[0, 1.148, 0]}
                scale={0.332}
              >
                <mesh
                  name="Object_4"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_4.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Skeleton_2"
                position={[-11.979, -0.301, -14.284]}
                rotation={[Math.PI, -0.622, Math.PI]}
                scale={0.179}
              >
                <mesh
                  name="Object_9"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_9.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="SmallBoat_35"
                position={[16.884, 2.687, 13.412]}
                rotation={[0, 1.385, 0]}
                scale={0.471}
              >
                <mesh
                  name="Object_87"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_87.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Spyglass001_26"
                position={[-13.368, 11.736, 8.037]}
                rotation={[-Math.PI, -0.308, -3.091]}
              >
                <mesh
                  name="Object_66"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_66.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_67"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_67.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="Starfish001_283"
                position={[-12.573, -0.329, -11.555]}
                rotation={[0, -0.476, 0]}
                scale={1.888}
              >
                <mesh
                  name="Object_602"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_602.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Starfish002_280"
                position={[-3.477, 3.788, 21.127]}
                rotation={[0, -0.168, 0]}
                scale={2.518}
              >
                <mesh
                  name="Object_596"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_596.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Starfish003_281"
                position={[-7.391, 1.252, -4.535]}
                rotation={[0, -0.476, 0]}
                scale={1.888}
              >
                <mesh
                  name="Object_598"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_598.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Starfish004_282"
                position={[-3.013, 4.567, 12.297]}
                rotation={[0, 0.059, 0]}
                scale={2.186}
              >
                <mesh
                  name="Object_600"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_600.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Starfish_279"
                position={[-2.985, 3.72, 21.944]}
                scale={3.704}
              >
                <mesh
                  name="Object_594"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_594.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="Tree_284"
                position={[-0.855, 7.551, 1.127]}
                rotation={[-Math.PI, 0.041, -Math.PI]}
                scale={2.663}
              />
              <group
                name="TreeLikeCoral1002_215"
                position={[21.081, -0.271, 18.064]}
                rotation={[-3.128, 0.022, -2.982]}
                scale={0.438}
              >
                <mesh
                  name="Object_466"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_466.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1003_219"
                position={[-9.465, -0.242, -18.524]}
                rotation={[3.098, -0.022, 3.137]}
                scale={0.234}
              >
                <mesh
                  name="Object_474"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_474.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1004_223"
                position={[-15.258, -0.34, -17.635]}
                rotation={[-3.127, -0.005, -3.068]}
                scale={0.454}
              >
                <mesh
                  name="Object_482"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_482.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1005_227"
                position={[-14.323, 0.185, 17.864]}
                rotation={[3.118, -0.026, 3.141]}
                scale={0.372}
              >
                <mesh
                  name="Object_490"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_490.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1006_231"
                position={[-15.86, 0.115, 20.278]}
                rotation={[3.106, 0.011, 3.129]}
                scale={0.19}
              >
                <mesh
                  name="Object_498"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_498.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1007_235"
                position={[-17.418, -0.309, -17.635]}
                rotation={[3.137, 0.052, -3.055]}
                scale={0.263}
              >
                <mesh
                  name="Object_506"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_506.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1008_239"
                position={[-16.589, -0.271, -14.441]}
                rotation={[-3.116, -0.02, -3.131]}
                scale={0.244}
              >
                <mesh
                  name="Object_514"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_514.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1009_243"
                position={[-18.105, -0.218, -12.044]}
                rotation={[-3.106, -0.011, -3.087]}
                scale={0.3}
              >
                <mesh
                  name="Object_522"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_522.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1010_247"
                position={[-17.418, -0.25, -11.156]}
                rotation={[3.108, -0.023, 3.069]}
                scale={0.229}
              >
                <mesh
                  name="Object_530"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_530.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1011_251"
                position={[-16.31, 0.753, 17.692]}
                rotation={[3.127, 0.039, -2.897]}
                scale={0.257}
              >
                <mesh
                  name="Object_538"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_538.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1012_255"
                position={[-18.004, -0.054, 20.242]}
                rotation={[3.098, 0.008, -3.028]}
                scale={0.199}
              >
                <mesh
                  name="Object_546"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_546.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1013_259"
                position={[-19.578, -0.34, -17.635]}
                rotation={[-3.128, -0.022, -2.935]}
                scale={0.448}
              >
                <mesh
                  name="Object_554"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_554.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1014_263"
                position={[-18.749, -0.271, -12.281]}
                rotation={[-3.118, -0.006, 2.98]}
                scale={0.336}
              >
                <mesh
                  name="Object_562"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_562.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1015_267"
                position={[-20.169, -0.092, 18.083]}
                rotation={[-3.141, 0.03, -2.983]}
                scale={0.395}
              >
                <mesh
                  name="Object_570"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_570.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral1016_271"
                position={[-21.738, -0.285, -13.316]}
                rotation={[-3.125, -0.016, -2.997]}
                scale={0.47}
              >
                <mesh
                  name="Object_578"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_578.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2002_216"
                position={[16.454, -0.228, 9.555]}
                rotation={[3.13, 0.041, -3.123]}
                scale={0.475}
              >
                <mesh
                  name="Object_468"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_468.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2003_220"
                position={[-8.778, -0.331, -19.795]}
                rotation={[-3.105, -0.007, -3.119]}
                scale={0.538}
              >
                <mesh
                  name="Object_476"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_476.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2004_224"
                position={[-14.43, -0.248, -16.601]}
                rotation={[3.134, 0.014, -3.12]}
                scale={0.339}
              >
                <mesh
                  name="Object_484"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_484.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2005_228"
                position={[-15.665, 0.824, 17.937]}
                rotation={[-3.094, -0.012, 3.129]}
                scale={0.257}
              >
                <mesh
                  name="Object_492"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_492.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2006_232"
                position={[-17.418, -0.331, -19.795]}
                rotation={[-3.117, 0, -3.109]}
                scale={0.584}
              >
                <mesh
                  name="Object_500"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_500.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2007_236"
                position={[-16.589, -0.401, -16.601]}
                rotation={[3.1, 0.029, 3.109]}
                scale={1.057}
              >
                <mesh
                  name="Object_508"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_508.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2008_240"
                position={[-18.105, -0.407, -14.204]}
                rotation={[3.13, 0.006, -2.848]}
                scale={0.28}
              >
                <mesh
                  name="Object_516"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_516.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2009_244"
                position={[-17.418, -0.295, -13.316]}
                rotation={[-3.14, 0.021, -2.984]}
                scale={1.023}
              >
                <mesh
                  name="Object_524"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_524.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2010_248"
                position={[-16.589, -0.237, -10.121]}
                rotation={[3.105, -0.026, -2.958]}
                scale={0.885}
              >
                <mesh
                  name="Object_532"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_532.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2011_252"
                position={[-17.797, 0.691, 17.862]}
                rotation={[3.135, -0.001, -2.898]}
                scale={0.609}
              >
                <mesh
                  name="Object_540"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_540.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2012_256"
                position={[-17.175, 0.548, 18.834]}
                rotation={[-3.114, 0.017, -3.095]}
                scale={0.893}
              >
                <mesh
                  name="Object_548"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_548.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2013_260"
                position={[-18.749, -0.379, -14.441]}
                rotation={[-3.121, -0.026, 3.121]}
                scale={0.314}
              >
                <mesh
                  name="Object_556"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_556.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2014_264"
                position={[-20.25, -0.189, 16.017]}
                rotation={[3.141, -0.014, -2.848]}
                scale={0.368}
              >
                <mesh
                  name="Object_564"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_564.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeLikeCoral2015_268"
                position={[-19.489, -0.035, 16.822]}
                rotation={[3.13, 0.016, -2.885]}
                scale={1.097}
              >
                <mesh
                  name="Object_572"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_572.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TreeToHouse1_79"
                position={[4.577, 8.195, 3.505]}
                rotation={[-0.332, 0.278, 0.094]}
                scale={[0.182, 0.182, 0.13]}
              >
                <mesh
                  name="Object_194"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_194.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="TreeToHouse2_80"
                position={[3.748, 7.74, 2.351]}
                rotation={[2.81, -0.278, -0.094]}
                scale={[0.182, 0.182, 0.13]}
              >
                <mesh
                  name="Object_196"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_196.geometry}
                  material={materials.Base_Palette}
                />
              </group>
              <group
                name="TubularCorals1002_213"
                position={[20.773, -0.218, 11.714]}
                rotation={[3.134, 0.008, -3.097]}
                scale={0.797}
              >
                <mesh
                  name="Object_462"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_462.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1003_217"
                position={[-4.459, -0.364, -19.795]}
                rotation={[3.126, 0, -2.836]}
                scale={0.91}
              >
                <mesh
                  name="Object_470"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_470.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1004_221"
                position={[-7.95, -0.401, -16.601]}
                rotation={[3.137, 0.037, 3.024]}
                scale={0.559}
              >
                <mesh
                  name="Object_478"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_478.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1005_225"
                position={[-15.945, -0.417, -16.364]}
                rotation={[3.121, 0.024, -2.887]}
                scale={0.714}
              >
                <mesh
                  name="Object_486"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_486.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1006_229"
                position={[-15.147, 0.119, 16.824]}
                rotation={[-3.132, 0.034, -2.914]}
                scale={0.779}
              >
                <mesh
                  name="Object_494"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_494.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1007_233"
                position={[-16.589, -0.379, -18.761]}
                rotation={[3.129, 0.037, -3.072]}
                scale={0.683}
              >
                <mesh
                  name="Object_502"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_502.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1008_237"
                position={[-18.105, -0.407, -14.204]}
                rotation={[-3.131, -0.016, -2.921]}
                scale={0.541}
              >
                <mesh
                  name="Object_510"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_510.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1009_241"
                position={[-17.418, -0.319, -15.476]}
                rotation={[3.114, -0.005, 3.004]}
                scale={0.387}
              >
                <mesh
                  name="Object_518"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_518.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1010_245"
                position={[-16.589, -0.237, -10.121]}
                rotation={[3.123, 0.029, 3.025]}
                scale={0.34}
              >
                <mesh
                  name="Object_526"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_526.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1011_249"
                position={[-18.027, -0.154, 15.947]}
                rotation={[-3.103, 0.037, -2.838]}
                scale={0.607}
              >
                <mesh
                  name="Object_534"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_534.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1012_253"
                position={[-17.252, 0.197, 16.753]}
                rotation={[3.139, 0.002, 2.969]}
                scale={0.847}
              >
                <mesh
                  name="Object_542"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_542.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1013_257"
                position={[-18.749, -0.271, -18.761]}
                rotation={[-3.141, 0.021, -3]}
                scale={1.088}
              >
                <mesh
                  name="Object_550"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_550.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1014_261"
                position={[-20.264, -0.407, -12.044]}
                rotation={[-3.129, -0.018, -2.827]}
                scale={0.349}
              >
                <mesh
                  name="Object_558"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_558.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1015_265"
                position={[-19.564, -0.282, 14.747]}
                rotation={[3.11, 0, -2.889]}
                scale={0.899}
              >
                <mesh
                  name="Object_566"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_566.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals1016_269"
                position={[-18.506, 0.443, 17.688]}
                rotation={[3.139, -0.003, -2.964]}
                scale={0.977}
              >
                <mesh
                  name="Object_574"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_574.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2002_214"
                position={[21.46, -0.295, 10.443]}
                rotation={[3.088, 0.021, -3.06]}
                scale={0.314}
              >
                <mesh
                  name="Object_464"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_464.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2003_218"
                position={[-5.79, -0.271, -18.761]}
                rotation={[3.128, -0.028, -3.139]}
                scale={1.012}
              >
                <mesh
                  name="Object_472"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_472.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2004_222"
                position={[-9.465, -0.233, -14.204]}
                rotation={[3.138, -0.015, 3.04]}
                scale={0.858}
              >
                <mesh
                  name="Object_480"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_480.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2005_226"
                position={[-15.258, -0.331, -15.476]}
                rotation={[3.137, -0.055, 3.03]}
                scale={0.801}
              >
                <mesh
                  name="Object_488"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_488.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2006_230"
                position={[-14.387, -0.044, 20.08]}
                rotation={[3.141, 0.043, -3.13]}
                scale={0.931}
              >
                <mesh
                  name="Object_496"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_496.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2007_234"
                position={[-18.105, -0.242, -18.524]}
                rotation={[3.132, 0.001, -3.01]}
                scale={0.77}
              >
                <mesh
                  name="Object_504"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_504.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2008_238"
                position={[-17.418, -0.319, -15.476]}
                rotation={[3.118, -0.004, -2.823]}
                scale={0.479}
              >
                <mesh
                  name="Object_512"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_512.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2009_242"
                position={[-16.589, -0.216, -12.281]}
                rotation={[-3.114, 0.048, 3.026]}
                scale={0.721}
              >
                <mesh
                  name="Object_520"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_520.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2010_246"
                position={[-18.105, -0.403, -9.884]}
                rotation={[3.135, 0.001, -2.939]}
                scale={0.494}
              >
                <mesh
                  name="Object_528"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_528.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2011_250"
                position={[-17.252, 0.197, 16.753]}
                rotation={[-3.117, -0.009, -2.892]}
                scale={0.505}
              >
                <mesh
                  name="Object_536"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_536.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2012_254"
                position={[-16.465, 0.213, 20]}
                rotation={[3.134, -0.041, -2.987]}
                scale={0.739}
              >
                <mesh
                  name="Object_544"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_544.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2013_258"
                position={[-20.264, -0.407, -18.524]}
                rotation={[3.115, -0.004, -2.856]}
                scale={0.552}
              >
                <mesh
                  name="Object_552"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_552.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2014_262"
                position={[-19.578, -0.319, -13.316]}
                rotation={[3.125, 0.002, -2.874]}
                scale={0.638}
              >
                <mesh
                  name="Object_560"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_560.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2015_266"
                position={[-18.506, 0.443, 17.688]}
                rotation={[-3.11, 0.002, -2.989]}
                scale={0.366}
              >
                <mesh
                  name="Object_568"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_568.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="TubularCorals2016_270"
                position={[-20.239, -0.353, 20.324]}
                rotation={[-3.121, -0.005, 3.135]}
                scale={0.905}
              >
                <mesh
                  name="Object_576"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_576.geometry}
                  material={materials["Base_Palette.Corals"]}
                />
              </group>
              <group
                name="Water_120"
                position={[0, 2.262, 0]}
                rotation={[-Math.PI, 0, -Math.PI]}
                scale={[22.546, 17.681, 22.546]}
              />
              <group
                name="Well001_434"
                position={[-5.582, 4.198, 8.144]}
                rotation={[-1.298, 0.163, 1.274]}
              >
                <mesh
                  name="Object_911"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_911.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_912"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_912.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="Well_433"
                position={[-3.858, 5.856, 7.616]}
                rotation={[0, 0.693, 0]}
              >
                <mesh
                  name="Object_908"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_908.geometry}
                  material={materials.Base_Palette}
                />
                <mesh
                  name="Object_909"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_909.geometry}
                  material={materials.MetallicPalette}
                />
              </group>
              <group
                name="WoodenStool_421"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="YeOl'Lantern001_67"
                position={[5.182, 8.612, 7.609]}
                rotation={[0, -0.863, 0]}
                scale={0.08}
              >
                <mesh
                  name="Object_168"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_168.geometry}
                  material={materials.MetallicPalette}
                />
                <mesh
                  name="Object_169"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_169.geometry}
                  material={materials.EmissivePalette}
                />
              </group>
              <group
                name="YeOl'Lantern002_419"
                position={[1.528, 2.588, -0.437]}
                rotation={[0, 1.312, 0]}
                scale={0.92}
              />
              <group
                name="YeOl'Lantern_74"
                position={[3.553, 14.976, 5.69]}
                rotation={[0, -0.874, 0]}
                scale={3.468}
              >
                <mesh
                  name="Object_183"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_183.geometry}
                  material={materials.MetallicPalette}
                />
                <mesh
                  name="Object_184"
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_184.geometry}
                  material={materials.EmissivePalette}
                />
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>

{/* </RigidBody> */}
  </>
}

useGLTF.preload("/models/pirate_island.glb");
